var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseCircleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7H8V13H9V7Z",
    fill: "#2968C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7H11V13H12V7Z",
    fill: "#2968C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4C11.1867 4 12.3467 4.35189 13.3334 5.01118C14.3201 5.67047 15.0892 6.60754 15.5433 7.7039C15.9974 8.80026 16.1162 10.0067 15.8847 11.1705C15.6532 12.3344 15.0818 13.4035 14.2426 14.2426C13.4035 15.0818 12.3344 15.6532 11.1705 15.8847C10.0067 16.1162 8.80026 15.9974 7.7039 15.5433C6.60755 15.0892 5.67047 14.3201 5.01119 13.3334C4.3519 12.3467 4 11.1867 4 10C4 8.4087 4.63214 6.88258 5.75736 5.75736C6.88258 4.63214 8.4087 4 10 4ZM10 3C8.61553 3 7.26216 3.41054 6.11101 4.17971C4.95987 4.94888 4.06266 6.04213 3.53285 7.32122C3.00303 8.6003 2.86441 10.0078 3.13451 11.3656C3.4046 12.7235 4.07129 13.9708 5.05026 14.9497C6.02922 15.9287 7.2765 16.5954 8.63437 16.8655C9.99224 17.1356 11.3997 16.997 12.6788 16.4672C13.9579 15.9373 15.0511 15.0401 15.8203 13.889C16.5895 12.7378 17 11.3845 17 10C17 8.14348 16.2625 6.36301 14.9497 5.05025C13.637 3.7375 11.8565 3 10 3Z",
    fill: "#2968C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseCircleBlue);
export default __webpack_public_path__ + "static/media/pause-circle-blue.943a994ac35330a98d2ed5e822dd68d6.svg";
export { ForwardRef as ReactComponent };